import styles from "./row.module.scss";

const Row = ({ children, type, rowContent, rowHref, rowName }) => {
  return (
    <div className={styles.row}>
      <div className={styles.row_icon}>{children}</div>
      <div className={styles.row_content}>
        {type === "link" ? (
          <ContentLink content={rowContent} href={rowHref} />
        ) : (
          <ContentText content={rowContent} />
        )}
        <h4 className={styles.row_content__name}>{rowName}</h4>
      </div>
    </div>
  );
};

const ContentLink = ({ href, content }) => {
  return (
    <h3 className={styles.row_content__value}>
      <a rel="noreferrer" target="_blank" href={href}>{content}</a>
    </h3>
  );
};

const ContentText = ({ content }) => {
  return <h3 className={styles.row_content__value}>{content}</h3>;
};

export default Row;
